// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signOut, updatePassword, sendEmailVerification } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";



// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyB0Vf-U73oq06oZoCqT8yBl0KHwOhZ5QvU",
  authDomain: "sp-community-workers.firebaseapp.com",
  projectId: "sp-community-workers",
  storageBucket: "sp-community-workers.firebasestorage.app",
  messagingSenderId: "719212899761",
  appId: "1:719212899761:web:725458e253e16872e5e190",
  measurementId: "G-B4MKXV6MJD"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Initialize auth with the app instance
const dbFirestore = getFirestore(app); // Initialize dbFirestore with the app instance
const storage = getStorage(app);


export { auth, dbFirestore, storage, onAuthStateChanged, signOut, updatePassword, sendEmailVerification }; // Export auth and dbFirestore directly
export default app;